import { request } from '@/utils/request'
//获取订单列表
export function getOrderTimelist(sessionId, status, pageNo, pageSize) {
    return request({
        url: `/api/v1/otorder/orderInfo/orderlist;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            status,
            pageNo,
            pageSize
        }
    });
}

//获取订单详情
export function getOrderDetails(sessionId, orderID) {
    return request({
        url: `/api/v1/otorder/orderInfo/orderdetail;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            orderID
        },
    });
}

//待支付订单 -- 立即支付

//立即支付
export function unpaidOrderPayment(sessionId, id, payMode, invoiceInfo) {
    return request({
        url: `/api/v1/otorder/orderInfo/payment;JSESSIONID=${sessionId}?__ajax=true`,
        method: 'post',
        data: {
            id,//订单id
            payMode,//支付方式
            invoiceInfo//发票信息
        }
    });
}
